module.exports = __webpack_public_path__ + "static/media/44.c1e6d32b.mp3";